// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-containers-homepage-index-tsx": () => import("./../../../src/containers/Homepage/index.tsx" /* webpackChunkName: "component---src-containers-homepage-index-tsx" */)
}

